import React from "react";
import PrettyDate from "../../components/PrettyDate";
import DirectionType from "../../components/DirectionType";
import {communicatedViaToDisplay, valueOrEmDash} from "../../../common/displayUtils";
import {LIGHT_TEXT_COLOR} from "../../common/styles";
import {tdStyles} from "../../components/tableStyles";

const presentationStyle = {
    padding: "20px",
    margin: 0,
    borderBottom: "1px solid rgba(0,0,0,0.15)"
};

const linkStyle = {
    color: "#0078e7"
};

const communicatorStyle = {
    display: "inline-block",
    width: 90,
    verticalAlign: "top",
    marginRight: 10
};

const CommunicatedPresentation = ({communicationDetails: {communicator, communicationTimestamp, communicationMethod}, presentation: {legs}}) => (
    <div style={presentationStyle}>
        {communicator
            ? <div style={communicatorStyle}>
                <span className="x-communicator-name">{communicator.name}</span><br/>
                <span style={{color: LIGHT_TEXT_COLOR}}
                      className="x-communicator-company-name">{communicator.companyName}</span>
            </div>
            : <div style={communicatorStyle}/>
        }
        <div style={{display: "inline-block", width: 90, verticalAlign: "top", marginRight: 10}}>
            <PrettyDate className="x-communication-date" timeOnSameLine={true} date={communicationTimestamp}/><br />
            <span style={{color: LIGHT_TEXT_COLOR}} className="x-communication-method">{communicatedViaToDisplay(communicationMethod)}</span>
        </div>

        <table style={{display: "inline-block", width: 610, verticalAlign: "top"}}>
            <tbody>
            {legs.map(({legId, direction, referenceData, derivativeDescription, targetPrice, marketPrice}, index) => {
                const isLastRow = index === legs.length - 1;
                const borderStyle = isLastRow ? {border: "none"} : {};

                return (
                    <tr key={legId}>
                        <td style={{...tdStyles, width: 25, ...borderStyle}}>
                            <DirectionType direction={direction}/>
                        </td>
                        <td style={{...tdStyles, width: 165, ...borderStyle}}>
                            <span className="x-recommendable-name">{referenceData.companyName}</span><br/>
                            <span className="x-recommendable-isin"
                                  style={{color: LIGHT_TEXT_COLOR, fontSize: "80%"}}>{referenceData.isin}</span>
                        </td>
                        <td style={{...tdStyles, width: 75, ...borderStyle}}
                            className="x-derivative-description">{derivativeDescription}</td>
                        <td style={{...tdStyles, width: 60, ...borderStyle}}
                            className="x-target-price">{valueOrEmDash(targetPrice)}</td>
                        <td style={{...tdStyles, width: 60, ...borderStyle}}
                            className="x-market-price">{valueOrEmDash(marketPrice)}</td>
                        <td style={{...tdStyles, width: 105, ...borderStyle}}>
                            <a style={linkStyle} target="_blank" className="x-disclosure-link" href={`#/recommendations/${legId}`}>view disclosures</a>
                        </td>
                    </tr>
                );
            })}
            </tbody>
        </table>
    </div>
);

CommunicatedPresentation.propTypes = {
    communicationDetails: React.PropTypes.shape({
        communicator: React.PropTypes.shape({name: React.PropTypes.string, companyName: React.PropTypes.string}),
        communicationTimestamp: React.PropTypes.string,
        communicationMethod: React.PropTypes.string
    }),
    presentation: React.PropTypes.shape({
        productionTimestamp: React.PropTypes.string,
        validityPeriod: React.PropTypes.string,
        legs: React.PropTypes.arrayOf(React.PropTypes.shape({
            referenceData: React.PropTypes.shape({
                companyName: React.PropTypes.string,
                isin: React.PropTypes.string
            }),
            direction: React.PropTypes.string,
            derivativeDescription: React.PropTypes.string,
            targetPrice: React.PropTypes.string,
            marketPrice: React.PropTypes.string
        }))
    })
};

export default CommunicatedPresentation;



/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/portal/components/CommunicatedPresentation.js
 **/